module.exports = __webpack_public_path__ + "img/chinesecompany20.7186ede8.png";